/**
 * Firebase Cloud Messaging (FCM) — Configuration
 *
 * Note: la configuration Firebase Web n'est pas un secret au sens strict
 * (elle est embarquée dans le bundle JS), mais nous la passons par variables
 * d'environnement pour rester cohérent avec le reste du projet.
 *
 * Référence: https://firebase.google.com/docs/projects/api-keys
 */
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

/**
 * Récupère (ou initialise) l'app Firebase de façon idempotente.
 * Évite l'erreur "Firebase: Firebase App named '[DEFAULT]' already exists".
 */
export function getFirebaseApp() {
  if (!firebaseConfig.apiKey) return null;
  return getApps().length ? getApp() : initializeApp(firebaseConfig);
}

/**
 * Récupère l'instance Messaging si le navigateur supporte FCM.
 * Retourne null sur Safari iOS < 16.4, navigateurs sans Service Worker, etc.
 */
export async function getFirebaseMessaging() {
  try {
    const app = getFirebaseApp();
    if (!app) return null;
    const supported = await isSupported();
    if (!supported) return null;
    return getMessaging(app);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[FCM] getMessaging error:', err);
    return null;
  }
}
